import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { fetchObjects } from "../actions/fetchObjects.actions";
import { useDebounce } from "../../../../../../../../shared/hooks/useDebounce";

export const useObjectsPagination = (pageSize = 10, searchText = "") => {
  const [page, setPage] = useState(1);
  const token = sessionStorage.getItem("token");

  const debouncedSearch = useDebounce(searchText, 400);
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["objects", page, debouncedSearch],
    queryFn: () => fetchObjects(page, pageSize, token, debouncedSearch),
  });

  // PREFETCH NEXT PAGE
  useEffect(() => {
    if (!query.data) return;
    const nextPage = page + 1;

    if (nextPage <= query.data.totalPages) {
      queryClient.prefetchQuery({
        queryKey: ["objects", nextPage, debouncedSearch],
        queryFn: () => fetchObjects(nextPage, pageSize, token, debouncedSearch),
      });
    }
  }, [page, query.data, queryClient, pageSize, token, debouncedSearch]);

  // Reset page when new search
  useEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

  return {
    ...query,
    page,
    totalPages: query.data?.totalPages ?? 1,
    items: query.data?.items ?? [],
    goNextPage: () => {
      if (query.data && page < query.data.totalPages) setPage((p) => p + 1);
    },
    goPrevPage: () => {
      if (page > 1) setPage((p) => p - 1);
    },
    setSearchText: (v: string) => { },
  };
};
